/**
 * Loading spinner — shown within 300ms of request start.
 * Accessible with aria-label for screen readers.
 */

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export function LoadingSpinner({ size = 'md', label = 'Caricamento in corso...' }: LoadingSpinnerProps) {
  return (
    <div className={`spinner spinner-${size}`} role="status" aria-label={label}>
      <div className="spinner-circle" />
      <span className="sr-only">{label}</span>
    </div>
  );
}

/**
 * Full-page loading overlay.
 */
export function PageLoader({ message }: { message?: string }) {
  return (
    <div className="page-loader">
      <LoadingSpinner size="lg" label={message || 'Caricamento...'} />
      {message && <p>{message}</p>}
    </div>
  );
}
